// import React, { useState } from "react";
// import "./LoginModal.css";
// import loginGif from "../Assets/login.gif";
// import signupGif from "../Assets/man.gif";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const LoginModal = ({ closeModal }) => {
//   const [isSignup, setIsSignup] = useState(false);
//   const [email, setEmail] = useState("");
//   const [name, setName] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const url = `http://localhost:5000/api/auth/${isSignup ? "signup" : "login"}`;
//       const payload = isSignup ? { name, email, password } : { email, password };

//       const response = await axios.post(url, payload);

//       if (response.data.token) {
//         localStorage.setItem("token", response.data.token);
//         localStorage.setItem("user", JSON.stringify(response.data.user));

      
//         window.dispatchEvent(new Event("user-logged-in")); // Notify other components

//         toast.success(`${isSignup ? "Signup" : "Login"} successful!`);
//         closeModal();
//         navigate("/");
//       } else {
//         toast.error(response.data.msg);
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.msg || "Server error");
//     }
//   };

//   return (
//     <div className="modal-overlay" onClick={closeModal}>
//       <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//         <span className="close-btn" onClick={closeModal}>&times;</span>
//         <h2>
//           <img
//             src={isSignup ? signupGif : loginGif}
//             alt={isSignup ? "Sign Up" : "Login"}
//             className="auth-gif"
//           />
//         </h2>
//         <form onSubmit={handleSubmit}>
//           {isSignup && (
//             <input
//               type="text"
//               placeholder="Full Name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               required
//             />
//           )}
//           <input
//             type="email"
//             placeholder="Email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//           />
//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             required
//           />
//           <button type="submit">{isSignup ? "Sign Up" : "Login"}</button>
//         </form>
//         <p>
//           {isSignup ? "Already have an account?" : "Don't have an account?"}
//           <span
//             onClick={() => setIsSignup(!isSignup)}
//             className="switch-text"
//           >
//             {isSignup ? " Login" : " Sign Up"}
//           </span>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default LoginModal;

import React, { useState } from "react";
import "./LoginModal.css";
import loginGif from "../Assets/login.gif";
import signupGif from "../Assets/man.gif";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  auth,
  googleProvider,
} from "../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  sendPasswordResetEmail,
  signInWithPopup,
} from "firebase/auth";

const LoginModal = ({ closeModal }) => {
  const [isSignup, setIsSignup] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const navigate = useNavigate();

  const validatePassword = (pwd) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/;
    return regex.test(pwd);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSignup && !validatePassword(password)) {
      toast.error(
        "Password must contain uppercase, lowercase, special character, and be at least 8 characters long."
      );
      return;
    }

    try {
      if (isSignup) {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        await updateProfile(userCredential.user, { displayName: name });
        toast.success("Signup successful! Please login now.");
        setIsSignup(false); // Switch to login after signup
        setPassword("");
      } else {
        const userCredential = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );
        toast.success("Login successful!");
        localStorage.setItem(
          "user",
          JSON.stringify({
            name: userCredential.user.displayName,
            email,
            uid: userCredential.user.uid,
          })
        );
        closeModal();
        navigate("/");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleSocialLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      localStorage.setItem(
        "user",
        JSON.stringify({
          name: user.displayName,
          email: user.email,
          uid: user.uid,
        })
      );
      toast.success(`Welcome, ${user.displayName}`);
      closeModal();
      navigate("/");
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleResetPassword = async () => {
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      toast.success("Password reset email sent!");
      setShowReset(false);
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <span className="close-btn" onClick={closeModal}>
          &times;
        </span>
        <h2>
          <img
            src={isSignup ? signupGif : loginGif}
            alt={isSignup ? "Sign Up" : "Login"}
            className="auth-gif"
          />
        </h2>

        {showReset ? (
          <>
            <h3>Reset Password</h3>
            <input
              type="email"
              placeholder="Enter your email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
              required
            />
            <button onClick={handleResetPassword}>Send Reset Link</button>
            <p>
              Back to{" "}
              <span
                className="switch-text"
                onClick={() => setShowReset(false)}
              >
                Login
              </span>
            </p>
          </>
        ) : (
          <>
            <form onSubmit={handleSubmit}>
              {isSignup && (
                <input
                  type="text"
                  placeholder="Full Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              )}
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {isSignup && password && !validatePassword(password) && (
                <div className="password-feedback">
                  Password must include:
                  <ul>
                    <li>✓ At least 8 characters</li>
                    <li>✓ Uppercase & lowercase letters</li>
                    <li>✓ A special character</li>
                    <li>✓ Require numeric character</li>
                  </ul>
                </div>
              )}
              <button type="submit">
                {isSignup ? "Sign Up" : "Login"}
              </button>
            </form>

            {!isSignup && (
              <p className="reset-password">
                <span onClick={() => setShowReset(true)}>Forgot Password?</span>
              </p>
            )}

            <div className="social-login">
              <p>Or sign in with</p>
              <div className="social-icons">
                <button onClick={handleSocialLogin} className="google-btn">
  <img src="https://upload.wikimedia.org/wikipedia/commons/4/4a/Logo_2013_Google.png" alt="Google logo" className="google-logo" />
</button>

              </div>
            </div>

            <p>
              {isSignup
                ? "Already have an account?"
                : "Don't have an account?"}
              <span
                onClick={() => setIsSignup(!isSignup)}
                className="switch-text"
              >
                {isSignup ? " Login" : " Sign Up"}
              </span>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginModal;
